const ITEMS = [
  "50,000 Sq.Ft Facility",
  "30 Service Bays",
  "6 Months Warranty",
  "OEM / OES Spares",
  "Advanced Diagnostics",
  "Multi-Brand Expertise",
  "Premium Care",
  "Tirupur",
];

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {ITEMS.map((item) => (
      <span
        key={item + (ariaHidden ? "-b" : "-a")}
        className="flex items-center whitespace-nowrap"
      >
        <span className="px-6 font-display text-xs font-semibold uppercase tracking-[0.35em] text-ivory/40">
          {item}
        </span>
        <span className="h-1 w-1 rotate-45 bg-gold/60" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-gold/10 bg-ink py-5"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
